import { trackPromise } from "react-promise-tracker";
import { axiosBridge } from "../network/AxiosBridge";
import { API_URL, StatusCodes } from "../network/Configurations";

const assignLabelToRecruiter = (params: any): Promise => {
  return new Promise((resolve, reject) => {
    trackPromise(
      axiosBridge
        .post(API_URL.ASSIGN_LABEL, {}, { params })
        .then((response) => {
          if (response.data.code === StatusCodes.SUCCESS) {
            resolve(response.data);
          } else reject(response.data);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        })
    );
  });
};

const markRecruiterVerified = (params: any): Promise => {
  return new Promise((resolve, reject) => {
    trackPromise(
      axiosBridge
        .put(API_URL.MARK_USER_VERIFIED, {}, { params })
        .then((response) => {
          if (response.data.code === StatusCodes.SUCCESS) {
            resolve(response.data);
          } else reject(response.data);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        })
    );
  });
};

const addRecruiter = (request: any): Promise => {
  return new Promise((resolve, reject) => {
    trackPromise(
      axiosBridge
        .post(API_URL.ADD_USER, request)
        .then((response) => {
          if (response.data.code === StatusCodes.SUCCESS) {
            resolve(response.data);
          } else reject(response.data);
        })
        .catch((error) => {
          reject(error);
        })
    );
  });
};

const updateRecruiter = (request: any): Promise => {
  return new Promise((resolve, reject) => {
    trackPromise(
      axiosBridge
        .put(API_URL.UPDATE_USER, request)
        .then((response) => {
          if (response.data.code === StatusCodes.SUCCESS) {
            resolve(response.data);
          } else reject(response.data);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        })
    );
  });
};

const deleteRecruiters = (params: any): Promise => {
  return new Promise((resolve, reject) => {
    trackPromise(
      axiosBridge
        .delete(API_URL.DELETE_USER_PROFILES, { params })
        .then((response) => {
          if (response.data.code === StatusCodes.SUCCESS) {
            resolve(response.data);
          } else reject(response.data);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        })
    );
  });
};

const getRecruiterById = (params: any): Promise => {
  return new Promise((resolve, reject) => {
    trackPromise(
      axiosBridge
        .get(API_URL.GET_PROFILE_BY_ID, { params })
        .then((response) => {
          if (response.data.code === StatusCodes.SUCCESS) {
            resolve(response.data);
          } else reject(response.data);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        })
    );
  });
};

const getRecruiterList = (params): Promise => {
  return new Promise((resolve, reject) => {
    trackPromise(
      axiosBridge
        .get(`${API_URL.GET_USERS_LIST}?categoryType=Recruiter`, { params })
        .then((response) => {
          if (
            response.data.code === StatusCodes.SUCCESS ||
            response.data.code === StatusCodes.NO_DATA_FOUND
          ) {
            resolve(response.data);
          } else reject(response.data);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        })
    );
  });
};

const getRecruiterProfileList = (params): Promise => {
  return new Promise((resolve, reject) => {
    trackPromise(
      axiosBridge
        .get(`${API_URL.GET_USERS_LIST}?categoryType=Recruiter`, { params })
        .then((response) => {
          if (
            response.data.code === StatusCodes.SUCCESS ||
            response.data.code === StatusCodes.NO_DATA_FOUND
          ) {
            resolve(response.data);
          } else reject(response.data);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        })
    );
  });
};

const getAuditionListForRecruiter = (params): Promise => {
  return new Promise((resolve, reject) => {
    trackPromise(
      axiosBridge
        .get(API_URL.GET_USER_AUDITIONS, { params })
        .then((response) => {
          if (
            response.data.code === StatusCodes.SUCCESS ||
            response.data.code === StatusCodes.NO_DATA_FOUND
          ) {
            resolve(response.data);
          } else reject(response.data);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        })
    );
  });
};

const getImagesList = (params): Promise => {
  return new Promise((resolve, reject) => {
    trackPromise(
      axiosBridge
        .get(`${API_URL.GET_USERS_MEDIA}?mediaType=Image`, { params })
        .then((response) => {
          if (
            response.data.code === StatusCodes.SUCCESS ||
            response.data.code === StatusCodes.NO_DATA_FOUND
          ) {
            resolve(response.data);
          } else reject(response.data);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        })
    );
  });
};

export const RecruiterService = {
  assignLabelToRecruiter,
  markRecruiterVerified,
  addRecruiter,
  updateRecruiter,
  deleteRecruiters,
  getRecruiterById,
  getRecruiterList,
  getRecruiterProfileList,
  getAuditionListForRecruiter,
  getImagesList,
};
